<template>
  <button
    ref="refButtonShareQr"
    class="button-white button-icon button-icon-bigger button-rounded"
    @click="onClickButtonShareQr"
    :class="{ active: isVisible }"
  >
    <QrManageIcon class="icon-medium" />
    <p>{{ $t('invite_others') }}</p>
  </button>

  <DropdownShareQr
    v-if="isVisibleModalShareQr"
    :host-qr-code-image-url="callStore.qrCodeInfo.hostQrCodeImageUrl"
    :host-link-url="callStore.qrCodeInfo.hostLinkUrl"
    :guest-qr-code-image-url="callStore.qrCodeInfo.guestQrCodeImageUrl"
    :guest-link-url="callStore.qrCodeInfo.guestLinkUrl"
    :target-el="refButtonShareQr"
    @copy="copyToClipboard"
    @close="closeModalShareQr"
    class="shareqr-con"
  />
</template>

<script setup lang="ts">
import { ref, useTemplateRef } from 'vue';
import { useI18n } from 'vue-i18n';

import DropdownShareQr from '@/components/domains/chat/common/DropdownShareQr.vue';
import QrManageIcon from '@/components/icons/IconQrManage.vue';
import { useGtag } from '@/composables/shared/useGtag';
import { useCallStore } from '@/stores/call';

const { t } = useI18n();

const callStore = useCallStore();

const { trackEventClick } = useGtag();

const refButtonShareQr = useTemplateRef('refButtonShareQr');
const isVisible = ref<boolean>(false);
const copyEmployeeText = ref(t('copy'));
const copyGuestText = ref(t('copy'));
const isVisibleModalShareQr = ref(false);

const copyToClipboard = (type) => {
  if (type === 'EMPLOYEE') {
    trackEventClick('chat', '호스트 URL 복사하기');
    copyEmployeeText.value = t('copy_completed');
  } else {
    trackEventClick('chat', '게스트 URL 복사하기');
    copyGuestText.value = t('copy_completed');
  }

  let url;
  if (type === 'EMPLOYEE') {
    url = callStore.qrCodeInfo.hostLinkUrl;
  } else {
    url = callStore.qrCodeInfo.guestLinkUrl;
  }

  navigator.clipboard
    .writeText(url)
    .then(() => {
      setTimeout(async () => {
        if (type === 'EMPLOYEE') {
          copyEmployeeText.value = t('copy');
        } else {
          copyGuestText.value = t('copy');
        }
      }, 2000);
    })
    .catch((err) => {
      console.error('클립보드 복사 실패:', err);
    });
  //
};

const openModalShareQr = () => {
  trackEventClick('chat', 'QR 초대하기');
  isVisibleModalShareQr.value = true;
};

const closeModalShareQr = () => {
  isVisibleModalShareQr.value = false;
};

const onClickButtonShareQr = () => {
  if (isVisibleModalShareQr.value) {
    closeModalShareQr();
  } else {
    openModalShareQr();
  }
};
</script>

<style scoped lang="scss">
button p {
  display: none;
}

@include respond-from(desktop) {
  button p {
    display: inline;
  }
}
</style>
